import { useEmbarcacaoEquipamentos } from "../../../../hooks/use-embarcacao-equipamentos";
import { EMPTY_FIELD_PLACEHOLDER, latestAtualizacao } from "../../../detail-format/detail-format";
import { buildDetailFields } from "../../../detail-format/detail-fields";
import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import {
  EQUIPAMENTOS_EMPTY_STATE,
  EQUIPAMENTOS_FIELDS,
  EQUIPAMENTOS_ID,
  EQUIPAMENTOS_LOADING_MESSAGE,
  EQUIPAMENTOS_TEST_ID,
  EQUIPAMENTOS_TITLE,
} from "./equipamentos-section.constants";

/** Seção Equipamentos do detalhamento da embarcação: somente leitura, com os campos já formatados para a View. */
export function useEquipamentosSection({
  embarcacaoId,
  onReauthenticate,
}: EmbarcacaoDetailSectionProps) {
  const { status, equipamentos, errorMessage, reload } = useEmbarcacaoEquipamentos(embarcacaoId);

  return {
    id: EQUIPAMENTOS_ID,
    title: EQUIPAMENTOS_TITLE,
    testId: EQUIPAMENTOS_TEST_ID,
    fieldsTestId: `${EQUIPAMENTOS_TEST_ID}-fields`,
    status,
    errorMessage,
    loadingMessage: EQUIPAMENTOS_LOADING_MESSAGE,
    emptyContent: EQUIPAMENTOS_EMPTY_STATE,
    onReauthenticate,
    onRetry: reload,
    // Só há data de atualização a exibir quando a seção tem dados.
    ultimaAtualizacao: equipamentos
      ? latestAtualizacao([equipamentos.ultimaAtualizacao, equipamentos.atualizacaoEquipamentos])
      : undefined,
    fields: buildDetailFields(
      equipamentos,
      EQUIPAMENTOS_FIELDS,
      EQUIPAMENTOS_TEST_ID,
      EMPTY_FIELD_PLACEHOLDER,
    ),
  };
}
